'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _reactBootstrap = require('react-bootstrap');

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _reactIntl = require('react-intl');

var _components = require('../../components');

var _DropdownItem = require('../../components/Dropdown/DropdownItem');

var _createLoginClient = require('../../helpers/createLoginClient');

var _createLoginClient2 = _interopRequireDefault(_createLoginClient);

var _DefaultString = require('../../helpers/DefaultString');

var _Error = require('../../helpers/Error');

var _ClientError = require('../../helpers/ClientError');

var _Login = require('../../helpers/Login');

var _Login2 = _interopRequireDefault(_Login);

var _Logs = require('../../helpers/Logs');

var _Provider = require('../../helpers/Provider');

var _Router = require('../../helpers/Router');

var _auth = require('../../redux/modules/auth');

var _AllProviders = require('./AllProviders.scss');

var _AllProviders2 = _interopRequireDefault(_AllProviders);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var close = require('./../../../res/images/svgExcludeInline/close.svg');

var buttonClear = '#button_clear';
var searchMinChar = 2;

var AllProviders = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    appInfo: state.appInfo,
    auth: state.auth,
    log: state.log };
}, { startGracePeriod: _auth.startGracePeriod, pushState: _reactRouterRedux.push }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(AllProviders, _Component);

  function AllProviders(props) {
    (0, _classCallCheck3.default)(this, AllProviders);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AllProviders.__proto__ || (0, _getPrototypeOf2.default)(AllProviders)).call(this, props));

    _this.onChangeFilter = function (newFilter) {
      _this.setState({ selectedFilter: newFilter });
      _this.getList(newFilter.filterId);
    };

    _this.onHideResults = function () {
      _this.setState({ showResults: false });
    };

    _this.onProvider = function (provider) {
      (0, _Provider.navigateToAuthorization)(provider, _this.props.pushState, _this.props.auth, _this.props.startGracePeriod);
    };

    _this.getList = function (filter) {
      _this.setState({ operatorList: null, loading: true });
      (0, _createLoginClient2.default)().then(function (loginClient) {
        return loginClient.operator.getOperatorList({
          languageTag: _this.props.auth.lang,
          clientId: _this.props.auth.clientId,
          filter: filter }, { responseContentType: 'application/json' }).then(function (result) {
          _this.setState({ operatorList: result.obj.operatorList, loading: false });
        }).catch(function (error) {
          (0, _Error.logError)(error.statusText);
        });
      }).catch(function (error) {
        (0, _ClientError.createLoginClientError)(error, new Error().stack, _this.props.pushState, _this.props.auth);
      });
    };

    _this.getHighlightedProviderName = function (providerName) {
      var providerNameHighlighted = providerName;
      var searchValue = _this.state.searchValue.toLowerCase();
      var length = searchValue.length;
      var openBold = '<b>';
      var closeBold = '</b>';
      for (var index = providerNameHighlighted.toLowerCase().indexOf(searchValue); index >= 0; index = providerNameHighlighted.toLowerCase().indexOf(searchValue, index + length + openBold.length + closeBold.length)) {
        var endIndex = index + length;
        providerNameHighlighted = providerNameHighlighted.substr(0, index) + openBold + providerNameHighlighted.substr(index, length) + closeBold + providerNameHighlighted.substr(endIndex);
      }
      return providerNameHighlighted;
    };

    _this.clearInput = function () {
      _this.setState({ searchValue: '', searchResults: null });
      _this.onHideResults();
    };

    _this.navigateToProviderNotListed = function () {
      _this.props.pushState((0, _Router.getPath)(_Router.RouterConst.Welcome + '/' + _Router.RouterConst.ProviderNotListed));
    };

    _this.handleInputChange = function (event) {
      var searchText = event.target.value;
      _this.setState({ searchValue: searchText });

      if (searchText.length >= searchMinChar) {
        (0, _createLoginClient2.default)().then(function (loginClient) {
          return loginClient.operator.getOperatorList({
            languageTag: _this.props.auth.lang,
            clientId: _this.props.auth.clientId,
            filter: _Provider.ProviderFilter.SearchName,
            name: searchText }, { responseContentType: 'application/json' }).then(function (result) {
            _this.setState({ searchResults: result.obj.operatorList, showResults: true });
          }).catch(function (error) {
            (0, _Error.logError)(error.statusText);
          });
        }).catch(function (error) {
          (0, _ClientError.createLoginClientError)(error, new Error().stack, _this.props.pushState, _this.props.auth);
        });
      } else {
        _this.setState({ showResults: false });
      }
    };

    _this.handleOnFocus = function () {
      if (_this.state.searchResults && _this.state.searchValue.length >= searchMinChar) {
        _this.setState({ showResults: true });
      }
    };

    _this.hasSearchResults = function (providerList) {
      for (var pos = 0; pos < providerList.length; pos += 1) {
        if ((0, _Provider.isValidProvider)(providerList[pos])) {
          return true;
        }
      }
      return false;
    };

    _this.renderProvider = function () {
      return _react2.default.createElement(
        'div',
        { key: _this.state.operatorList },
        _this.state.operatorList.map(function (provider) {
          return (0, _Provider.isValidProvider)(provider) ? _react2.default.createElement(
            'div',
            { key: provider.id, className: _AllProviders2.default.listItem, onClick: function onClick() {
                return _this.onProvider(provider);
              } },
            ' ',
            provider.name,
            ' '
          ) : '';
        })
      );
    };

    var localItem = new _DropdownItem.DropdownItem(_Provider.ProviderDropdownId.Local, _Provider.ProviderFilter.CurrentCountry, '', _DefaultString.translations.AllProvidersFilterLocal);
    var allItem = new _DropdownItem.DropdownItem(_Provider.ProviderDropdownId.All, _Provider.ProviderFilter.All, '', _DefaultString.translations.AllProvidersFilterAll);

    _this.state = {
      loading: true,
      searchValue: '',
      operatorList: null,
      filters: [localItem, allItem],
      selectedFilter: localItem,
      searchResults: null,
      showResults: false
    };
    return _this;
  }

  (0, _createClass3.default)(AllProviders, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getList(this.state.selectedFilter.filterId);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.auth.startingGracePeriod && !nextProps.auth.startingGracePeriod) {
        if (!nextProps.auth.error) {
          (0, _Login2.default)(nextProps.auth.sessionId, nextProps.auth, this.props.log, this.props.appInfo, this.props.pushState, _Logs.LogEventSelectedOptions.Trial);
        } else {
          (0, _ClientError.createLoginClientError)(this.props.auth.error, new Error().stack, this.props.pushState, this.props.auth);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var dropDownItem = this.state.filters;
      var formatMessage = this.props.intl.formatMessage;
      var _state = this.state,
          operatorList = _state.operatorList,
          searchResults = _state.searchResults,
          showResults = _state.showResults;


      return _react2.default.createElement(
        'div',
        { className: _AllProviders2.default.allProviders },
        _react2.default.createElement(
          'div',
          { className: _AllProviders2.default.title },
          _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.ProvidersTitle)
        ),
        _react2.default.createElement(
          'div',
          { className: _AllProviders2.default.search + (showResults ? ' ' + _AllProviders2.default.showResults : '') },
          _react2.default.createElement('div', { className: _AllProviders2.default.overlay, onClick: this.onHideResults }),
          _react2.default.createElement(
            'div',
            { className: _AllProviders2.default.searchInput },
            _react2.default.createElement(_reactBootstrap.FormControl, {
              className: _AllProviders2.default.textInput,
              name: 'searchProvider',
              type: 'text',
              value: this.state.searchValue,
              placeholder: formatMessage(_DefaultString.translations.AllProvidersSearchPlaceholder),
              onChange: this.handleInputChange,
              onFocus: this.handleOnFocus
            }),
            _react2.default.createElement(
              'div',
              { className: _AllProviders2.default.close },
              _react2.default.createElement(_components.SVGLocal, { viewBox: '0 0 18.38 18.375', link: close + buttonClear, className: _AllProviders2.default.clearIcon, onClick: this.clearInput })
            )
          ),
          showResults ? _react2.default.createElement(
            'div',
            { key: 'openResults', className: _AllProviders2.default.searchResults },
            _react2.default.createElement(
              'div',
              { className: _AllProviders2.default.resultsContent },
              this.hasSearchResults(searchResults) ? searchResults.map(function (provider) {
                return (0, _Provider.isValidProvider)(provider) ? _react2.default.createElement('div', {
                  key: provider.id,
                  className: _AllProviders2.default.searchItem,
                  onClick: function onClick() {
                    return _this2.onProvider(provider);
                  },
                  dangerouslySetInnerHTML: { __html: _this2.getHighlightedProviderName(provider.name) }
                }) : '';
              }) : _react2.default.createElement(
                'div',
                { className: _AllProviders2.default.searchItem },
                _react2.default.createElement(_reactIntl.FormattedHTMLMessage, (0, _extends3.default)({}, _DefaultString.translations.AllProvidersSearchNoResult, {
                  values: { text: this.state.searchValue }
                }))
              )
            )
          ) : _react2.default.createElement('div', { key: 'closeResults' })
        ),
        _react2.default.createElement(_components.CustomDropdown, { className: _AllProviders2.default.dropdown, items: dropDownItem, onItemClick: this.onChangeFilter, selectedItem: this.state.selectedFilter }),
        _react2.default.createElement(
          'div',
          { className: _AllProviders2.default.list },
          _react2.default.createElement(
            'div',
            { className: _AllProviders2.default.listContent },
            _react2.default.createElement(
              _reactAddonsCssTransitionGroup2.default,
              {
                transitionName: 'fadeInOutProvider',
                transitionEnterTimeout: 250,
                transitionLeaveTimeout: 100
              },
              operatorList ? this.renderProvider() : _react2.default.createElement(_components.LoadingIndicator, { key: this.state.loading, loading: this.state.loading })
            )
          )
        ),
        _react2.default.createElement(_components.BaseButton, { className: _AllProviders2.default.button, buttonString: _DefaultString.translations.ProviderNotListed, onClick: this.navigateToProviderNotListed })
      );
    }
  }]);
  return AllProviders;
}(_react.Component), _class2.propTypes = {
  appInfo: _react.PropTypes.object,
  auth: _react.PropTypes.object,
  log: _react.PropTypes.object,
  intl: _reactIntl.intlShape.isRequired,
  pushState: _react.PropTypes.func.isRequired,
  startGracePeriod: _react.PropTypes.func.isRequired
}, _temp)) || _class);
exports.default = (0, _reactIntl.injectIntl)(AllProviders);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/AllProviders/AllProviders.js
// module id = 1991
// module chunks = 0